module.exports = __webpack_public_path__ + "static/img/agent-3.ca43eeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent-3.jpg
// module id = otCL
// module chunks = 1